<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->

<template>
	<div class="rest-api-add website-setup website-setup__body">
		<div>
			<div class="mdc-layout-grid website-setup__grid">
				<div class="mdc-layout-grid__inner center-horizontal mdc-theme--dark mdc-theme--text-primary-on-dark">

					<!-- LANDING MESSAGE -->
					<section class="section-landing mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.STAGE0">
						<div class="website-setup__icon"><img src="/static/img/website-setup.png" alt="" class=""></div>
						<h3 class="website-setup__landing-text">Give your supplier<br> Rest API access<br> in just <span>3 easy steps</span></h3>
						<a class="mdc-button mdc-button--raised" @click.prevent="stage = stages.STAGE1">Let's go!</a>
					</section>

					<!-- STAGE 1 - SUPPLIER COMPANY -->
					<section class="section-about mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.STAGE1">
						<h3 class="margin-bottom-40">Tell us the company name of your supplier</h3>
						<div class="width-100 mdc-textfield mdc-textfield--upgraded company-registration__companies-house">
			             <companies-house-input id="companies-house" title="Company name/number" @changed="companyData"></companies-house-input>
			         </div>
						<div v-if="supplier.company.hasOwnProperty('company_number')">
							Company Number: {{supplier.company.company_number}}<br>
							Company Address: {{supplier.company.address_snippet}}<br>
							Company Status: {{supplier.company.company_status}}<br>
							Creation Date: {{supplier.company.date_of_creation}}
						</div>
						<a class="mdc-button mdc-button--raised" @click.prevent="stage = stages.STAGE2">Next</a>
						<div class="btn-back"><a @click.prevent="stage = stages.STAGE0">&lt; back</a></div>
					</section>

					<!-- STAGE 2 - SUPPLIER EMAIL -->
					<section class="section-about mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.STAGE2">
						<h3 class="margin-bottom-40">We also need your supplier's email to send them the details</h3>
						<div class="width-100 mdc-textfield mdc-textfield--upgraded">
			 			   <input class="mdc-textfield__input" type="text" v-model="supplier.email" placeholder="" />
			 			   <label class="mdc-textfield__label mdc-textfield__label--float-above">Supplier Email</label>
			 		  </div>
						<a class="mdc-button mdc-button--raised" @click.prevent="stage = stages.STAGE3">Next</a>
						<div class="btn-back"><a @click.prevent="stage = stages.STAGE1">&lt; back</a></div>
					</section>

					<!-- STAGE 3 - PERMISSIONS -->
					<section class="section-about mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.STAGE3">
						<h3 class="margin-bottom-40">Finally, we just need the permissions you want to give to the supplier</h3>
						<div class="mdc-form-field width-100" v-for="item in permissions">
							<div class="mdc-checkbox">
								<input :id="item.id" :value="item.id" class="mdc-checkbox__native-control" type="checkbox" v-model="supplier.permissions">
								<div class="mdc-checkbox__background"></div>
							</div>
							<label :for="item.id">{{ item.name }}</label>
						</div>
						<button-with-spinner class="btn--spinner__wide-btn" :isSaving="isSaving" :text="isSaving ? 'Sending supplier Rest API Access...' : 'SEND IT'" :customMethod="addSupplier" :disabled="isSaving"></button-with-spinner>
						<div class="btn-back"><a @click.prevent="stage = stages.STAGE2">&lt; back</a></div>
					</section>

					<!-- SUCCESS -->
					<section class="section-success mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.SUCCESS">
						<div>
							<h2>An email was sent to your supplier with instructions on how to start using BestAgent Rest API</h2>
							<div class="website-setup__icon website-setup__success-icon"><img src="/static/img/success_thumbs.png" alt="" class=""></div>
							<a class="mdc-button mdc-button--raised" @click.prevent="$router.push('/settings/rest-api')">Rest API Settings</a>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import ButtonWithSpinner  from '../components/ButtonWithSpinner.vue';
import CompaniesHouseInput  from '../components/CompaniesHouseInput.vue';

export default {
	data: function() {
		return {
			stages: {
				STAGE0:		0,
				STAGE1:		1,
				STAGE2:		2,
				STAGE3:		3,
				SUCCESS:		4
			},
			stage: 0,
			isSaving: false,
			supplier: {
				company: {},
				email: '',
				permissions: []
			},
			permissions: [
				{id: 'properties-read', name: 'Read Properties'},
				{id: 'properties-write', name: 'Add/Edit Property'},
				{id: 'applicants-read', name: 'Read Applicants'},
				{id: 'applicants-write', name: 'Add/Edit Applicant'},
			]
		}
	},
	mixins: [utils],
	computed: {
	},
	components: {
		'button-with-spinner': ButtonWithSpinner,
		'companies-house-input': CompaniesHouseInput,
	},
	mounted: async function(){
	},
	methods: {
		companyData: function(data) {
			this.supplier.company = data;
			console.log(data);
		},
		addSupplier: async function() {
			const self = this;
			self.isSaving = true;
			try {
				const response = await api({endpoint: this.config.services.rest, path: '/keys', method: 'POST', body: this.supplier});
				self.isSaving = false;
				self.stage = self.stages.SUCCESS;
			} catch(err) {
				console.error('ERROR:', err);
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Settings-RestAPI-Add.vue